define([
    'react',
    'lodash'
], function (React, _) {
    'use strict';
    return function () {
        return React.createElement('div', { 'className': 'b-onboarding__tour' }, React.createElement('p', {
            'className': 'image',
            'style': { backgroundImage: 'url(/images/people/onboarding-hendrik.jpg)' }
        }), React.createElement('p', { 'className': 'title' }, 'Hello, Fredrik Wollsén!'), React.createElement('p', {}, 'I\'m Fred from Clerk and I\'m here to help you with onboarding.'), React.createElement('p', {}, 'Clerk handles accounting admin differently from any other system you may be used to.\n        Clerk learns from the past and focuses on generating approximate accounting and\n        street-smart advice before aiding you to stay compliant.\n        See Clerk as a trusted personal assistant that does work for you.\n        '    /* The more information shared with Clerk, the more Clerk can do for you. */), React.createElement('div', { 'className': 'ask' }, React.createElement('p', { 'className': 'headline' }, 'Got a question?'), React.createElement('ul', {}, React.createElement('li', {}, React.createElement('a', { 'href': '/faq' }, 'Check our FAQ')), React.createElement('li', {}, React.createElement('a', {
            'href': '#',
            'onClick': console.log('click registered??')
        }, 'Ask our\n                support')))), React.createElement('div', {
            'className': 'b-onboarding__question',
            'style': { display: 'none' },
            'id': 'questionblock'
        }, React.createElement('form', {
            'action': '/onboarding/question',
            'method': 'post'
        }, React.createElement('input', {
            'type': 'hidden',
            'name': '_csrf',
            'value': '32d9a401-7be1-4ec5-a556-a88963b5937e'
        }), React.createElement('p', {}, React.createElement('textarea', {
            'name': 'question',
            'rows': '5',
            'cols': '50',
            'placeholder': 'Post your question here ...',
            'required': 'required'
        })), React.createElement('p', { 'className': 'b-onboarding__actions' }, React.createElement('input', {
            'type': 'submit',
            'className': 'c-button m-small m-mail',
            'value': 'Send question'
        })))));
    };
});


//////////////////
// WEBPACK FOOTER
// .-dna/app/components/onboarding/OnboardingHello.html.rt
// module id = 4317
// module chunks = 86